import a from"./loadImage.js";import o from"./preloadImages.js";const e={loadImage:a,preloadImages:o};export{e as default};
//# sourceMappingURL=index.js.map
